import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function LeadsFunnel(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    d: "M14.05 19.871V22.5a.5.5 0 01-.5.5h-3.138a.5.5 0 01-.5-.507l.037-2.622L4 13h16l-5.95 6.871zM12.499 7c1.395 0 2.499-1.092 2.499-2.471C15.056 3.149 13.894 2 12.499 2S10 3.15 10 4.529C10 5.85 11.162 7 12.499 7z"
  }), React.createElement(Path, {
    stroke: "#000",
    d: "M9.5 8.5c0 1.12-.88 2-2 2s-2-.88-2-2 .88-2 2-2 2 .88 2 2z"
  }), React.createElement(Path, {
    d: "M16.5 12c1.395 0 2.5-1.105 2.5-2.5S17.895 7 16.5 7A2.482 2.482 0 0014 9.5c0 1.395 1.163 2.5 2.5 2.5z"
  }));
}

export default LeadsFunnel;